<ion-content>
  <div class="center height-100">
    <p>{{texto}}</p>
  </div>
</ion-content>
